import PropTypes from 'prop-types';
import SmartImage from '../../smartImage/smartImage';
import MobileAppCard from '../../mobileApp/mobileApp';
import StarRating from '../../starRating/starRating';
import styles from './appRating.module.scss';

export default function AppRating({
  rating,
  reviewCount,
  starCount = 5,
  qrCode,
  phoneImage,
  appleAppIcon,
  googleAppIcon,
}) {
  const hasAppCtas = appleAppIcon || googleAppIcon;
  if (!rating && !phoneImage && !qrCode?.path && !hasAppCtas) {
    return null;
  }

  return (
    <div className={styles.appRating}>
      <div className={styles.card}>
        <div className={styles.ratingBlock}>
          {rating && <span className={styles.rating}>{rating}</span>}
          <span className={styles.stars}>
            <StarRating
              count={starCount}
              fillColor="var(--dds-palette-default-white)"
            />
          </span>
          {qrCode?.path && (
            <SmartImage
              className={styles.qrCode}
              src={qrCode.path}
              alt={qrCode.alt ?? ''}
              width={qrCode.width}
              height={qrCode.height}
            />
          )}
          {reviewCount && (
            <span className={styles.reviewCount}>{reviewCount}</span>
          )}
        </div>
        {hasAppCtas && (
          <div className={styles.appCtas}>
            <MobileAppCard
              appleAppIcon={appleAppIcon}
              googlePlayIcon={googleAppIcon}
            />
          </div>
        )}
        {phoneImage?.path && (
          <SmartImage
            className={styles.phoneImage}
            src={phoneImage.path}
            alt={phoneImage.alt ?? ''}
            width={phoneImage.width}
            height={phoneImage.height}
          />
        )}
        <div className={styles.gradient} aria-hidden="true" />
      </div>
    </div>
  );
}

AppRating.propTypes = {
  rating: PropTypes.string,
  reviewCount: PropTypes.string,
  starCount: PropTypes.number,
  qrCode: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  phoneImage: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  appleAppIcon: PropTypes.shape({
    imageurl: PropTypes.string,
    link: PropTypes.string,
    alt: PropTypes.string,
  }),
  googleAppIcon: PropTypes.shape({
    imageurl: PropTypes.string,
    link: PropTypes.string,
    alt: PropTypes.string,
  }),
};
